import { orientationTypes as promotionTypes } from '../../../promotions-page-grid/src/enums/orientation-types.enum';

export const verticalTypesEnum = Object.freeze({
    CASINO: 'casino',
    SPORT: 'sport',
    BINGO: 'bingo',
    LIVE_CASINO: 'liveCasino',
    SCRATCH_CARDS: 'scratchcards',
    JACKPOT: 'jackpot',
    RECOMMENDATIONS: 'recommendations',
    HOMEPAGE: 'homepage',
});

// PAM Game Vertical ID (GVID) Enum.
export const pamGVIDEnum = Object.freeze({
    ALL: null,
    TABLE: '240',
    RNG_TABLE: '241',
    RETAIL_INSTANT: '242',
    RETAIL_DBG: '243',
    BINGO: '244',
    ESCRATCH: '245',
    INSTANT: '246',
    DBG: '247',
    SPORT: '248',
    VIRTUAL_SPORTS: '249',
});

// Maps possible vertical types to PAM Game Vertical ID (GVID).
export const verticalTypesToPamGVIDEnum = Object.freeze({
    [verticalTypesEnum.CASINO]: pamGVIDEnum.INSTANT,
    [verticalTypesEnum.SPORT]: pamGVIDEnum.SPORT,
    [verticalTypesEnum.BINGO]: pamGVIDEnum.BINGO,
    [verticalTypesEnum.LIVE_CASINO]: pamGVIDEnum.INSTANT,
    [verticalTypesEnum.SCRATCH_CARDS]: pamGVIDEnum.INSTANT,
    [verticalTypesEnum.JACKPOT]: pamGVIDEnum.INSTANT,
    [verticalTypesEnum.RECOMMENDATIONS]: pamGVIDEnum.INSTANT,
    [verticalTypesEnum.HOMEPAGE]: pamGVIDEnum.INSTANT,
});

// Maps promotion orientation types to vertical types.
export const promotionOrientaionToVerticalTypeEnum = Object.freeze({
    [promotionTypes.CASINO]: verticalTypesEnum.CASINO,
    [promotionTypes.SPORT]: verticalTypesEnum.SPORT,
    [promotionTypes.ESPORTS]: verticalTypesEnum.CASINO,
    [promotionTypes.BINGO]: verticalTypesEnum.BINGO,
    [promotionTypes.JACKPOTS]: verticalTypesEnum.CASINO,
    [promotionTypes.OTHER]: verticalTypesEnum.CASINO,
});

export const verticalTypeToIdEnum = Object.freeze({
    [verticalTypesEnum.CASINO]: 1,
    [verticalTypesEnum.SPORT]: 2,
    [verticalTypesEnum.BINGO]: 3,
    [verticalTypesEnum.LIVE_CASINO]: 4,
    [verticalTypesEnum.SCRATCH_CARDS]: 5,
});

export const verticalActionTypesEnum = Object.freeze({
    CORE_CATEGORY: 'asgCoreCategory',
    CORE_ACTION: 'asgCoreAction',
    SPORT: 'sport',
    LOAD_GAME: 'loadGame',
    OPEN_LINK: 'openLink',
    MOBILE_APP_CATEGORY: 'mobileAppCategory',
    PLATFORM_CATEGORIES: 'virtualPlatformCategories',
    FEATURED_GAMES: 'featuredGamesCategory',
    BUYWIN_CATEGORY: 'buywinGamesCategory',
    JACKPOT_CATEGORY: 'asgJackpotCategory',
    JACKPOT_VIRTUAL_CATEGORIES: 'virtualJackpotCategories',
    JACKPOT_VIRTUAL_CATEGORY: 'virtualJackpotCategory',
    RECOMMENDATIONS_CATEGORY: 'recommendedGamesCategory',
    FAVORITES_CATEGORY: 'favoriteGamesCategory',
});
